import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../shared/components/base.component';
import {LoginService} from './login.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserPreferencesService} from '../shared/service/user-preferences.service';
import {AuthorizationService} from '../shared/service/authorization.service';
import {LoginSuccessResponse, LoginTwoFactorResponse} from '../shared/model/login-success-response';
import {environment} from '../../../environments/environment';
import { EnvironmentType } from '../shared/enums/enums';
import { LocalizationService } from '../shared/service/localization.service';
import {LoginRequest} from "../shared/model/login-request";
import {TwoFactorService} from "../shared/service/two-factor.service";
import {RedirectService} from "../shared/service/redirect.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends BaseComponent implements OnInit {

  public model: Pick<LoginRequest, 'username' | 'password' | 'keepMeLoggedIn'>;
  public isWrongCredentialsAlertVisible: boolean;
  public isUnConfirmedAccountAlertVisible: boolean;
  public isProccessing: boolean;
  public logoUrl: string;
  public applicationUrl: string;
  public registrationUrl: string;

  constructor(
      private loginService: LoginService,
      private router: Router,
      private route: ActivatedRoute,
      private userPreferencesService: UserPreferencesService,
      private authorizationService: AuthorizationService,
      private localizationService: LocalizationService,
      private twoFactor: TwoFactorService,
      private redirect: RedirectService,
    ) {
    super();
  }

  ngOnInit() {
    this.redirect.rememberFromURL();
    this.model = {username: '', password: '', keepMeLoggedIn: false};
    this.isWrongCredentialsAlertVisible = false;
    this.isUnConfirmedAccountAlertVisible = false;
    this.isProccessing = false;
    this.logoUrl = this.userPreferencesService.getCompanyLogoUrl();
    this.route.queryParams.subscribe(params => {
      const applicationType = params['application'];
      if (applicationType) {
        this.localizationService.getStartingLanguage().subscribe(culture => {
          this.loginService.getUrls(applicationType, culture).subscribe(
            (response) => {
              this.redirect.remember(response.applicationUrl)
              this.registrationUrl = response.registrationUrl;
            }
          );
        });
      }
    });
  }

  public onInputFocus() {
    this.isWrongCredentialsAlertVisible = false;
    this.isUnConfirmedAccountAlertVisible = false;
  }

  public goToResetPasswordPage() {
    this.router.navigate(['reset-password'], {relativeTo: this.route.parent});
  }

  public redirectToRegisterForm() {
    if (this.registrationUrl != null) {
      window.open(this.registrationUrl, '_self');
    }
  }

  public onSubmit() {
    this.isProccessing = true;
    this.loginService.login(this.model.username, this.model.password, this.model.keepMeLoggedIn).subscribe(
      async response => await this.onLogin(response),
      error => {
        if(error.status === 403) {
          this.isUnConfirmedAccountAlertVisible = true;
        }
        else {
          this.isWrongCredentialsAlertVisible = true;
        }
        this.isProccessing = false;
      },
      () => this.isProccessing = false
    );
  }

  private async onLogin(response: LoginSuccessResponse | LoginTwoFactorResponse) {
    if ('twoFactor' in response) {
      await this.presentTwoFactor(response);
    } else {
      this.completeLogin(response);
    }
  }

  private completeLogin(response: LoginSuccessResponse) {
    if (environment.environmentName === EnvironmentType.LOCAL) {
      this.authorizationService.signInOnLocalEnv(response);
    } else {
      this.authorizationService.signIn();
    }
    this.redirectBackToAppOrGoToDashboard();
  }

  private redirectBackToAppOrGoToDashboard() {

    return this.redirect.restore('/dashboard');

  }

  public onKeepMeLoggedInChange(checked: boolean) {
    this.model.keepMeLoggedIn = checked;
  }

  private async presentTwoFactor(response: LoginTwoFactorResponse) {
    this.twoFactor.loginId = response.loginId;
    await this.router.navigate(['two-factor']);
  }
}

